import HomePage from './pages/HomePage';
import './App.css';

const App = () => <HomePage />;

export default App;
